export default __webpack_public_path__ + "search-examples-category-based-search-thumbnail-960-349c877a2ccd600efc0ddb4b83c762b0.webp";